import React, { useContext } from "react";
import { LanguageContext, LanguageContextConsumer } from "../../App";

class Loader extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
          selectedFile:{},
          fileResult:{},
          isSelected:false,
          fileContentJson:{},
          normalizePoints:true,
          linkInput : React.createRef()
        }
        this.renderParent = this.renderParent.bind(this)
    }

    componentDidMount(){
        const language = this.context
    }

    changeHandler = async (event) => {
        try{
            this.setState({...this.state,selectedFile:event.target.files[0],isSelected:true},()=>{
                this.props.onLoadFile()
            })
        }
        catch(error){
            //
        }
	}

    handleLoad=(e)=>{
        this?.changeHandler(e).then(()=>{
            this?.handleSubmission()
            this?.handleLoadLink(this?.state?.linkInput?.current?.value,true)
            let a = document.createElement('a')
            a.href = '#pld_animator'
            a.click()
        })
    }
    
    getFileContentJson=()=>{
        return this.state.fileContentJson
    }

    renderParent(){
        return (
            <LanguageContextConsumer>
            {(language)=>{
                return (
                    <div>
                        <div>
                            <label htmlFor="file-upload" className="custom-file-upload">
                                <i className="fa fa-cloud-upload"></i> {language.animator.upload_button}
                            </label>
                            <input id="file-upload" className='btn btn-secondary' type="file" name="file" onChange={(e)=>{this?.handleLoad(e)}} accept={this.props.accept}/>
                        </div>
                        {this.state.isSelected ? (
                            <></>/*
                            <div>
                                <p>Filename: {this.state?.selectedFile?.name}</p>
                                <p>Filetype: {this.state?.selectedFile?.type}</p>
                            </div>
                        */) : (
                            <></>/*
                            <p>Select a file to show details</p>
                        */)}
                        {
                            /*
                        <div className="form-group">
                            <p>{language?.animator?.upload_link?.message}</p>
                            <input ref={this.state.linkInput} onKeyUp={(e)=>{this?.handleLoadLink(e,false)}} type="link" className="form-control form-control-alternative" id="exampleFormControlInput1" placeholder={language?.animator?.upload_link?.place_holder}/>
                        </div>
                        
                        <div>
                            <button className='btn btn-info' onClick={this?.handleLoad}>{language?.animator?.upload_link?.load}</button>
                        </div>
                        */
                        }
                    </div>
                )
            }}
                
            </LanguageContextConsumer>
        )
    }

    render(){
        return false
    }
}

export default Loader